
const Countlykeys = {

    //连接钱包
    connect_click: 'walletConnect',

    //断开连接钱包
    disconnect_click: 'walletDisonnect',

    //ETH 购买并质押
    buyWithEthAndStake_click: 'buyWithEthAndStake',

    //ETH 购买
    buyWithEth_click: 'buyWithEth',

    //USDT 购买并质押
    buyWithUSDTAndStake_click: 'buyWithUSDTAndStake',

    //USDT 购买
    buyWithUSDT_click: 'buyWithUSDT',

    //USDC 购买并质押
    buyWithUSDCAndStake_click: 'buyWithUSDCAndStake',

    //USDC 购买
    buyWithUSDC_click: 'buyWithUSDC',


    //申请质押TGB
    stake_click: 'stakeTGB',

    //申请解除质押
    unstake_click: 'unstakeTGB',

    //领取质押奖励
    stakeReward_click: 'receiveStakingRewards',

    //审计
    audit_click: 'audit',

    //twitter
    twitter_click: 'twitter',

    //tg 频道
    tg_click: 'telegramChannel',

    //game tg 频道
    gameTg_click: 'gameTelegramChannel',

    //证书
    license_click: 'license',

    //白皮书
    whitePaper_click: 'whitePaper',

    //tg下载
    tgDownload_click: 'telegramDownload'
}

export { Countlykeys }

